import appData from '../../config/App_data';
import GetData from '../../RestAPI/getDataService';
import postData from '../../RestAPI/fetchData';

const fetchVideos = async (data) => {
  return await GetData.callAPI(`${appData.backend_api}/exams/frm/videos/all-videos`, data);
};
const fetchLastViewedVideo = async (data = {}) => {
  return await GetData.callAPI(`${appData.backend_api}/exams/frm/videos/last-video-viewed`, data);
};
const saveLastViewedVideo = async (data = {}) => {
  return await postData.callAPI(
    `${appData.backend_api}/frm_question_bank/saveLastViewedVideo`,
    data,
  );
};
module.exports = {
  fetchVideos,
  fetchLastViewedVideo,
  saveLastViewedVideo,
};



// WEBPACK FOOTER //
// ./src/views/FRM-V2/Videos/ApiService.js